<template>
  <div class="animated fadeIn">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <b-col sm="12" lg="8" class="pt-2 p-1 title">
              <span>Indicadores de Usuários Varejo</span>
            </b-col>
          </div>
          <b-form @submit.stop.prevent>
            <b-form-group label="Início" label-for="txt-data-inicio">
              <b-form-input type="date" id="txt-data-inicio" v-model="filters.initDate" class="mb-1 mr-sm-1 mb-sm-0"></b-form-input>
            </b-form-group>

            <b-form-group label="Fim" label-for="txt-data-fim">
              <b-form-input type="date" id="txt-data-fim" v-model="filters.endDate" class="mb-1 mr-sm-1 mb-sm-0"></b-form-input>
            </b-form-group>

            <div slot="footer">
              <b-row>
                <b-col sm="12" lg="2">
                  <b-button variant="secondary" class="form-control" @click="download">Download</b-button>
                </b-col>
              </b-row>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import { requestError, env, formatDate, isAllowed } from '@/shared/utils'
import _ from 'underscore'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'report_retail_user_indicators',
  components: {
    Loading
  },
  data: function() {
    return {
      filters: {},
      items: [],
      loadCount: 0,
    }
  },
  async mounted() {
    // await this.initialize();
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    },
  },
  methods: {
    formatDate(date) {
      return formatDate(date, "dd/MM/yyyy");
    },
    validate() {
      if (!this.filters.initDate || !this.filters.endDate) {
        alert("O período deve ser informado!");
        return false;
      }
      let diffDays = (new Date(this.filters.endDate) - new Date(this.filters.initDate)) / 1000 / 60 / 60 / 24;
      let limit = 30;
      if (diffDays > limit) {
        alert(`O período não deve exceder a ${limit} dias.`);
        return false;
      }
      return true;
    },
    async download () {
      if (!this.validate()) {
        return;
      }
      var _this = this;
      this.loadCount++;
      var format = "csv";
      await axios
        .get(this.getUrl(format),
          { responseType: 'arraybuffer' })
        .then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const fileName = `report-user-indicators-${+ new Date()}.${format}`;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    getUrl(format = null) {
      let url = `${env.urlBillingApi}/report-generator?reportType=retailIndicators&initDate=${this.filters.initDate}&endDate=${this.filters.endDate}`;
      if (format) {
        url += `&report=true&format=${format}`;
      }
      return url;
    },
    canGetAllCorporations() {
      return isAllowed('corporation_manager');
    },
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-usuarios-atual, #card-chart-usuarios-total, #card-chart-usuarios-pico, #card-chart-usuarios-ativos, #volumes-chart {
    width: 100% !important;
  }
</style>

<style scoped>
  .title {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>